import { StoreIcon } from 'lucide-react';

export const CustomerIcon = StoreIcon;
